import { render, staticRenderFns } from "./JobItemRequirements.vue?vue&type=template&id=36cea2eb"
import script from "./JobItemRequirements.vue?vue&type=script&lang=js"
export * from "./JobItemRequirements.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports